// extracted by mini-css-extract-plugin
module.exports = {"container":"_1c9529d521--container--t841O","title":"_1c9529d521--title--zgXrS","value":"_1c9529d521--value--MohP9"};